module.exports = __webpack_public_path__ + "img/instagram.3f4ce76d.svg";